import React from 'react';

// Cvik ve více partiích je v seznamu vícekrát (řádek za každou partii) – mapa ID cviku -> všechny jeho partie
export function getWorkoutMusclesMap(rows) {
	return (Array.isArray(rows) ? rows : []).reduce((accumulator, item) => {
		const muscleId = parseInt(item.MUSCLEID, 10) || 0;

		if (muscleId <= 0) {
			return accumulator;
		}

		if (!accumulator[item.ID]) {
			accumulator[item.ID] = [];
		}

		if (!accumulator[item.ID].some((muscle) => muscle.id === muscleId)) {
			accumulator[item.ID].push({id: muscleId, name: item.MUSCLE_NAME, color: item.COLOR});
		}

		return accumulator;
	}, {});
}

// Značka za názvem cviku – barevné tečky ostatních partií, ve kterých je cvik zařazen
export default function MultiMuscleBadge({muscles, currentMuscleId}) {
	const parsedCurrentMuscleId = parseInt(currentMuscleId, 10) || 0;
	const otherMuscles = (Array.isArray(muscles) ? muscles : []).filter((muscle) => muscle.id !== parsedCurrentMuscleId);

	if (otherMuscles.length === 0) {
		return null;
	}

	const label = `${otherMuscles.length === 1 ? 'Také v partii' : 'Také v partiích'}: ${otherMuscles.map((muscle) => muscle.name).join(', ')}`;

	return (
		<span className="multi-muscle-badge" title={label} aria-label={label} role="img">
			{otherMuscles.map((muscle) => (
				<span className="multi-muscle-badge__dot" key={muscle.id} style={{backgroundColor: muscle.color || '#8acaa3'}} />
			))}
		</span>
	);
}
